import { ErrorMessage } from '@videoblocks/user-service-client';

export function isErrorMessage(data: unknown): data is ErrorMessage {
    return typeof data === 'object' && data !== null && 'message' in data && typeof data.message === 'string';
}
